import { Routes, Route, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuthStore } from '@/store/authStore';
import { Layout } from '@/components/layout/Layout';
import { LoginPage } from '@/pages/Login';
import { DashboardPage } from '@/pages/Dashboard';
import { DocumentsPage } from '@/pages/Documents';
import { BusinessesPage } from '@/pages/Businesses';
import { InvestmentsPage } from '@/pages/Investments';
import { DeductionsPage } from '@/pages/Deductions';
import { TaxSummaryPage } from '@/pages/TaxSummary';
import { SettingsPage } from '@/pages/Settings';
import { SmartImportPage } from '@/pages/SmartImport';
import { TasksPage } from '@/pages/Tasks';
import { FilingGuidePage } from '@/pages/FilingGuide';
import { ChangelogPage } from '@/pages/Changelog';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuthStore();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

export default function App() {
  const { checkAuth, isAuthenticated } = useAuthStore();

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  return (
    <Routes>
      <Route path="/changelog" element={<ChangelogPage />} />
      <Route
        path="/login"
        element={
          isAuthenticated ? <Navigate to="/" replace /> : <LoginPage />
        }
      />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="smart-import" element={<SmartImportPage />} />
        <Route path="documents" element={<DocumentsPage />} />
        <Route path="businesses" element={<BusinessesPage />} />
        <Route path="investments" element={<InvestmentsPage />} />
        <Route path="deductions" element={<DeductionsPage />} />
        <Route path="tasks" element={<TasksPage />} />
        <Route path="tax-summary" element={<TaxSummaryPage />} />
        <Route path="filing-guide" element={<FilingGuidePage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
    </Routes>
  );
}
